import { AddButton } from './AddButton';
import { DropdownButton } from './DropdownButton';

type CategoryActionButtonProps = {
  isDisabled: boolean;
  showSingleChoiceAddButton: boolean;
  onOpenDrawerClick: () => void;
  isOpen: boolean;
  toggleOpen: () => void;
  addButtonPendoFeature?: string;
};

export const CategoryActionButton = ({
  isDisabled,
  showSingleChoiceAddButton,
  onOpenDrawerClick,
  isOpen,
  toggleOpen,
  addButtonPendoFeature,
}: CategoryActionButtonProps) => {
  if (isDisabled && showSingleChoiceAddButton) return null;
  if (showSingleChoiceAddButton)
    return (
      <AddButton onOpenDrawerClick={onOpenDrawerClick} isDisabled={isDisabled} pendoFeature={addButtonPendoFeature} />
    );

  return <DropdownButton isOpen={isOpen} toggleOpen={toggleOpen} />;
};
